import { useStore } from '@nanostores/react';
import { useMemo } from 'react';
import { useActiveBundle } from '@/context/active-bundle';
import { localCommandsAtom, type LocalCommand } from './local-commands';

function filterLocalCommands(commands: LocalCommand[], query: string): LocalCommand[] {
  if (query.length === 0) {
    return commands;
  }

  const lowerQuery = query.toLowerCase();
  return commands.filter((cmd) => {
    const searchText = [cmd.label, cmd.description, ...(cmd.keywords ?? [])].filter(Boolean).join(' ').toLowerCase();

    return searchText.includes(lowerQuery);
  });
}

/**
 * Returns local commands to show in the command dialog: commands for the active app
 * (from the store), filtered by the search query.
 */
export function useStoredHydraCommands(searchQuery: string): LocalCommand[] {
  const localCommandsMap = useStore(localCommandsAtom);
  const activeApp = useActiveBundle();

  return useMemo(() => {
    const commands: LocalCommand[] = [];
    for (const [, entry] of localCommandsMap) {
      if (activeApp === entry.app) {
        commands.push(...entry.commands);
      }
    }
    return filterLocalCommands(commands, searchQuery);
  }, [localCommandsMap, activeApp, searchQuery]);
}
